export const ringover = 'ghhapdfndmlhligpkofeppifkgddkonj';
export const ringoverNew = 'ojbfplnbnellgjfhgpnhodmjfikhfcnh';
export const aida = 'jfffkjidiedcedoimhlendkljhgffcfa';
export default {
  ringover,
  ringoverNew,
  aida
};
